import _ from 'lodash';

const tabletScreenWidth = 960;
export const isDesktopWidth = () => {
  return window.screen.availWidth > tabletScreenWidth;
};

export const  Carousel = () => {
  const $strategiesSlider = $('.js-strategies');

  $('.js-slider').owlCarousel({
    loop: true,
    items: 3,
    dots: true,
    autoplaySpeed: 500,
    autoplayHoverPause: true,
    autoplay: 4000,
    nav: true,
    margin: 30,
    responsive: {
      0: {
        items: 1,
        autoHeight: true
      },
      992: {
        autoHeight: false,
        items: 3
      }
    },
  });

  const strategiesCarouselOptions = {
    loop: true,
    items: 1,
    dots: true,
    autoplay: false,
    nav: true,
    margin: 0,
    smartSpeed: 1500,
    autoHeight: true
  };
  if (isDesktopWidth()) {
    strategiesCarouselOptions.animateOut = 'slideOutUp';
    strategiesCarouselOptions.animateIn = 'slideInUp';
  }
  $strategiesSlider.owlCarousel(strategiesCarouselOptions);

  const sliderFunc = _.throttle((delta) => {
    if (delta > 0) {
      $strategiesSlider.trigger('next.owl');
    } else {
      $strategiesSlider.trigger('prev.owl');
    }
  }, 2000, { 'trailing': false });

  $strategiesSlider.on('mousewheel', '.owl-stage', function (e) {
    sliderFunc(e.originalEvent.deltaY);
    e.preventDefault();
  });
};
